import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';  
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  constructor(public authService: AuthService,public router:Router) { }
  foto;
  ngOnInit() {
    var no_foto_="image-none.jpg";
    var foto=localStorage.getItem("foto");
    //console.log("--");
    //console.log(":::"+foto);
    if(foto===""){
      this.foto="https://hoshinup.garocedev.com:3007/"+ no_foto_;
    }else{
      this.foto="https://hoshinup.garocedev.com:3007/"+ foto;
    }  
  }
  regresa(){
    //this.router.navigate(["/lista_cliente_leady"]);
    this.router.navigate(["/lista_cliente"]);    
  }
  cerr_ses(){
    if(this.bndcerrar==true){
      this.bndcerrar=false;
    }else{
      this.bndcerrar=true;
    }
  }
  cerrar(){
    if(confirm("Confirma que desea cerrar sesión?")==true)this.router.navigate(["/"])
  }
  bndcerrar=false;
}
